import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tableModal from '@views/dashboard/st31/component/tableModal.vue';
import border from '@/components/border/borderType'; // import calendar from '@/components/Echart/calendar'

import calendarPie from '@/components/env-bigData/calendarPie';
import calendar from '@/components/env-bigData/calendar';
import monthSelect from '@/components/date/bmonthSelect'; // 空气质量指数表盘图
// 空气质量指数进度图
// 空气质量指数图

import schedule from '@/components/env-bigData/schedule'; // 空气质量天数表盘图

import plate from '@/components/env-bigData/plate'; // 空气质量天数双表盘图

import doublePlate from '@/components/env-bigData/doublePlate';
import analysis from '@/components/env-bigData/analysis';
import warn from '@/components/border/warn';
import fileTable from '@/components/border/fileTable';
import dial from '@/components/env-bigData/watch';
import { queryWastDateList, queryStandardTreeList, queryWastegasCurveAnalysis, querWastegasReport, standardWasteSkyMonth, queryWasteSkyStandBySite, queryScreenWarn, queryWastegasStand } from '@/api/api';
import TableModal from '@views/dashboard/st31/component/tableModal.vue';
export default {
  data: function data() {
    return {
      standState: false,
      standLabel: '',
      dateList: [],
      showRadio: true,
      firstPollution: {},
      showCalendar: true,
      waterWarnList: [],
      showDetail: false,
      showIt: false,
      defaultValue: 1,
      showAnalysis: false,
      showPie: true,
      showToast: false,
      stand: [],
      toastText: '',
      analysisType: 11,
      title: [],
      colors: ['#ccc'],
      showDial: false,
      defaultValues: 0,
      radioStatu: true
    };
  },
  components: {
    TableModal: TableModal,
    dial: dial,
    fileTable: fileTable,
    border: border,
    calendar: calendar,
    monthSelect: monthSelect,
    warn: warn,
    schedule: schedule,
    analysis: analysis,
    plate: plate,
    doublePlate: doublePlate,
    calendarPie: calendarPie
  },
  created: function created() {// this.getStandard()
  },
  mounted: function mounted() {// setInterval(this.scroll, 1000)
  },
  props: {
    selectId: {
      default: '0',
      type: String
    },
    selectType: {
      default: '0',
      type: String
    }
  },
  watch: {
    selectId: function selectId(val) {
      var _this = this;

      this.showRadio = false;
      this.$nextTick(function () {
        _this.showRadio = true;

        _this.$nextTick(function () {
          _this.defaultValues = 1;
          _this.analysisType = 11; // this.getStandard(val)

          _this.getReport(val);

          _this.getAirnow(val);

          _this.getPolutionData(val);

          _this.getWarn(_this.defaultValues, val, _this.selectType);

          _this.getwaterStand(val); // this.getSkyList(val)

        });
      });
    }
  },
  methods: {
    // 站点警报的tab切换
    changetadios: function changetadios(e) {
      this.defaultValues = e;
      if (e == 0) this.radioIndex = '';else this.radioIndex = e;
      this.getWarn(this.radioIndex, this.selectId, this.selectType); // this.getWarn(this.radioIndex,this.selectType)
    },
    //排放标准仪表
    getwaterStand: function getwaterStand(scopeId) {
      var _this2 = this;

      queryWastegasStand({
        scopeId: scopeId,
        scope: 1
      }).then(function (res) {
        console.log('res', res);

        if (res.success && res.result) {
          var color = [];
          var title = [];
          var a = [];
          var colors = ['green', 'red'];
          var date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res.result)[1]]; // date.push(Object.keys(res.result['同比标准'])[0])
          // date.push(Object.keys(res.result['实时标准'])[0])
          // date.push(Object.keys(res.result['环比标准'])[0])

          if (res.result[date[0]] != null && res.result[date[0]].upStandard != null) {
            if (res.result[date[0]].upStandard == true) {
              color.push(colors[0]);
              title.push('达标');
              a.push(1);
            } else {
              color.push(colors[1]);
              title.push('不达标');
              a.push(2);
            }
          } else {
            color.push('');
            title.push('');
            a.push(0);
          }

          if (res.result[date[1]] != null && res.result[date[1]].upStandard != null) {
            if (res.result[date[1]].upStandard == true) {
              color.push(colors[0]);
              title.push('达标');
              a.push(1);
            } else {
              color.push(colors[1]);
              title.push('不达标');
              a.push(2);
            }
          } else {
            color.push('');
            title.push('');
            a.push(0);
          }

          if (res.result[date[2]] && res.result[date[2]].upStandard != null) {
            if (res.result[date[2]].upStandard == true) {
              color.push(colors[0]);
              title.push('达标');
              a.push(1);
            } else {
              color.push(colors[1]);
              title.push('不达标');
              a.push(2);
            }
          } else {
            color.push('');
            title.push('');
            a.push(0);
          }

          _this2.showDial = true;

          _this2.$nextTick(function () {
            _this2.$refs.dials.initBarChart(title, color, date, a, 2);
          }); // let arr = []
          // let color = []
          // if(res.result['同比标准']){
          // 	color.push()
          // }
          // color.push()

        } else {
          _this2.showDial = true;

          var _date = new Date();

          var year1 = _date.getFullYear() - 1 + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

          var year2 = _date.getFullYear() + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

          var year3 = _date.getMonth() != 0 ? _date.getFullYear() + '-' + _date.getMonth() + '-' + _date.getDate() : _date.getFullYear() - 1 + '-12' + '-' + _date.getDate();

          _this2.$nextTick(function () {
            _this2.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 2);
          });
        }
      });
    },
    // 获取空气质量指数仪表盘数据
    getSkyList: function getSkyList(id) {
      var _this3 = this;

      queryWasteSkyStandBySite('id=' + id).then(function (res) {
        if (res.success && res.result) {
          _this3.$refs.plate.initBarChart(res.result['excellent']);

          _this3.$refs.doublePlate.initBarChart(res.result['PM25'], res.result['pollution']);
        } else {
          _this3.$refs.plate.initBarChart({
            someNum: 0,
            nowNum: 0
          });

          _this3.$refs.doublePlate.initBarChart({
            someNum: 0,
            nowNum: 0
          }, {
            someNum: 0,
            nowNum: 0
          });
        }
      });
    },
    // 获取排放趋势数据
    getPolutionData: function getPolutionData(id, start) {
      var _this4 = this;

      if (id) this.siteId = id;
      if (!start) start = this.getDay(0);
      queryWastegasCurveAnalysis({
        scopeId: this.siteId,
        dataType: this.analysisType,
        stime: start,
        type: 1,
        etime: this.getDay(0)
      }).then(function (res) {
        if (res.success) {
          if (res.result.records.length > 0) {
            var obj = {};
            var popArr = [];
            var arr = [];
            var time = [];
            var labelData = [];
            var seriesData = {};
            res.result.query.factors.forEach(function (ele) {
              labelData.push(ele.title);
              res.result.records.forEach(function (element) {
                if (element.factor[ele.code]) {
                  obj.name = element.dateStr;
                  obj.value = element.factor[ele.code].value != null ? element.factor[ele.code].value : 0;
                  arr.push(obj);
                  obj = {};
                }
              });
              seriesData.data = arr;
              seriesData.title = ele.title;
              popArr.push(seriesData);
              seriesData = {};
              arr = [];
            });
            res.result.records.forEach(function (data) {
              time.push(data.dataTime);
            });
            _this4.showAnalysis = false;

            _this4.$nextTick(function () {
              _this4.showAnalysis = true;
              setTimeout(function () {
                _this4.$refs.pollution.initBarChart(popArr, time, labelData);
              }, 100);
            });
          } else {
            _this4.showAnalysis = false;

            _this4.$nextTick(function () {
              _this4.showAnalysis = true;
              setTimeout(function () {
                _this4.$refs.pollution.initBarChart([], [], []);
              }, 100);
            });
          }
        }
      });
    },
    ontoGet: function ontoGet(value, year) {
      this.resetSetItem('siteId', this.selectId);
      this.resetSetLocalItem('treeSt', '31'); // window.localStorage.setItem('treeSt','21')

      this.resetSetItem('siteType', '31');

      if (value === '不达标') {
        this.$refs.tableModalRef.visible = true;
        this.$refs.tableModalRef.initData(year);
      }
    },
    // 获取国标数据
    getStandard: function getStandard(id) {
      var _this5 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          // res.result[0].children[0].children.forEach((item, index) => {
          //   item.data.title = item.data.title.replace('类', '')
          //   item.data.show = true
          //   return item
          // })
          var arr = [];
          var stand = [];
          _this5.colors = ['#ccc'];
          res.result.forEach(function (item, index) {
            if (item.label == '国家标准') {
              if (item.children != null) {
                item.children.forEach(function (item1, index1) {
                  if (item1.key == 'K1_2') {
                    arr = item1.children;
                    stand = JSON.parse(JSON.stringify(item1.children));
                    return;
                  }
                });
              }
            }
          });
          var colors = [];
          var title = [];
          arr.forEach(function (item, index) {
            // item.data.title = item.data.title.replace('类', '')
            colors.push(item.data.color);
            title.push(item.data.title); // return item
          });
          _this5.title = title; // // stand.forEach((item, index) => {
          // // 	item.data.title = item.data.title.replace('类', '')
          // // 	return item
          // // })

          _this5.colors = [].concat(colors, _toConsumableArray(_this5.colors));
          _this5.standardList = arr;
          _this5.stand = stand;
        }
      });
    },
    // 点击aqi  tab的切换
    changeRadio: function changeRadio(e) {
      var time;

      switch (e.target.value) {
        case 1:
          this.analysisType = 11;
          this.getPolutionData('', this.getDay(0));
          break;

        case 2:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(7));
          break;

        case 3:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(30));
          break;
      }
    },
    // 获取日期
    getDay: function getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate; // return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
    },
    doHandleMonth: function doHandleMonth(month) {
      var m = month;

      if (month.toString().length == 1) {
        m = '0' + month;
      }

      return m;
    },
    // 点击饼图图标
    ontoSelect: function ontoSelect() {
      this.showDetail = true;
      this.showIt = true;
    },
    scroll: function scroll() {
      var _this6 = this;

      setTimeout(function () {
        if (_this6.waterWarnList.length > 6) {
          _this6.waterWarnList.push(_this6.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this6.waterWarnList.shift(); //删除数组的第一个元素

        }

        if (_this6.dateList.length > 5) {
          _this6.dateList.push(_this6.dateList[0]); // 将数组的第一个元素添加到数组的


          _this6.dateList.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    // 普通日历日期选择器
    monthChange: function monthChange(value) {
      this.quantum = value;

      if (this.siteId) {
        this.getReport(this.siteId);
      } // let a = []
      // for (let i = 0; i < 31; i++) {
      // 	a.push(1)
      // }
      // this.$refs.calendar.initBarChart(this.quantum.split('-')[0], this.quantum.split('-')[1], a, ['red', 'blue'], ['I类',
      // 	'II类'
      // ])

    },
    getDaysInOneMonth: function getDaysInOneMonth(year, month) {
      month = parseInt(month, 10);
      var d = new Date(year, month, 0);
      return d.getDate();
    },
    // 获取空气日历数据
    getReport: function getReport(scopeId) {
      var _this7 = this;

      querWastegasReport({
        scopeId: scopeId,
        scope: 1,
        st: 31,
        type: 3,
        quantum: this.quantum
      }).then(function (res) {
        if (res.success) {
          var a = [];

          var num = _this7.getDaysInOneMonth(_this7.quantum.split('-')[0], _this7.quantum.split('-')[1]);

          res.result.forEach(function (item, index) {
            if (index < num) {
              if (item.exceeding !== null) {
                if (item.exceeding) a.push(2);else a.push(1);
              } else {
                a.push(0);
              }
            }
          });
          console.log('a', a);

          _this7.$refs.calendar.initBarChart(_this7.quantum.split('-')[0], _this7.quantum.split('-')[1], a, ['#ccc', 'green', 'red'], ['', '达标', '不达标']);
        }
      });
    },
    // 饼图日历日期选择器
    changemMonth: function changemMonth(value) {
      var _this8 = this;

      this.showPie = false;
      this.$nextTick(function () {
        _this8.showPie = true;

        if (_this8.siteId) {
          _this8.getStandmonth(_this8.siteId, value);
        }
      });
    },
    // 获取单个月标准次数饼图
    getStandmonth: function getStandmonth(id, quantum) {
      var _this9 = this;

      standardWasteSkyMonth({
        id: id,
        quantum: quantum
      }).then(function (res) {
        if (res.success) {
          var label = [];
          var a = [];
          var color = [];
          var arr = [];
          var data = [];
          res.result.standard.forEach(function (item, index) {
            label.push(item.title);
          });
          var monthArr = Object.keys(res.result.monthStandard);
          monthArr.forEach(function (item, index) {
            if (!(JSON.stringify(res.result.monthStandard[item]) == '{}')) {
              var arrs = [];
              var obj = {};

              for (var i = 0; i < res.result.standard.length; i++) {
                obj.name = res.result.standard[i].title;
                obj.color = res.result.standard[i].color;

                if (res.result.monthStandard[item][res.result.standard[i].title]) {
                  obj.value = res.result.monthStandard[item][res.result.standard[i].title].num;
                  color.push(res.result.standard[i].color);
                } else {
                  obj.value = 0;
                  color.push('');
                }

                data.push(obj);
                obj = {};
              }

              arr.push(data);
              data = [];
              color = [];
            } else {
              var _obj = {};

              for (var _i = 0; _i < res.result.standard.length; _i++) {
                color.push('');
                _obj.name = res.result.standard[_i].title;
                _obj.color = res.result.standard[_i].color;
                _obj.value = 0;
                data.push(_obj);
                _obj = {};
              }

              arr.push(data);
              data = [];
            }
          });

          _this9.$refs.pie.initBarChart(quantum, label, arr);
        }
      });
    },
    //获取预警内容
    getWarn: function getWarn(category, scopeId, st) {
      var _this10 = this;

      var params = {
        category: category,
        scope: 1,
        scopeId: scopeId,
        warnStatus: 1 // current: 1,
        // size: 20,

      }; // 污水站点

      queryScreenWarn(params).then(function (res) {
        if (res) {
          res.result.forEach(function (item, index) {
            switch (item.category) {
              case '1':
                item.category_dictText = '数据报警';
                break;

              case '2':
                item.category_dictText = '设备报警';
                break;

              case '4':
                item.category_dictText = '离线预警';
                break;
            }

            return item;
          });
          _this10.waterWarnList = res.result;
        }
      });
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var data = record.factor[code] || {
        value: ''
      };

      if (data.status == '2') {
        return "<span  style='color:green;padding-left:15px' class='redText' title='原始数据：  " + (data.raw != null ? data.raw : '一') + "'>" + (data.value != null ? data.value : '一') + "<div class='iconfont icon-xiangxiajiantou' style='float:right;color:green' ></div></span>";
      } else if (data.status == '3') {
        return "<span style='color:red;padding-left:15px' title='原始数据：" + (data.raw != null ? data.raw : '一') + "'>" + (data.value != null ? data.value : '一') + "<div class='iconfont icon-iconset0414' style='float:right;color:red' ></div></span>";
      } else {
        return "<span title='原始数据：" + (data.raw != null ? data.raw : '一') + "'>" + (data.value != null ? data.value : '一') + '</span>';
      }
    },
    // 获取空气质量实时数据
    getAirnow: function getAirnow(scopeId) {
      var _this11 = this;

      if (scopeId) this.siteId = scopeId;
      queryWastDateList({
        scopeId: scopeId,
        type: 1,
        st: 31,
        scope: 1
      }).then(function (res) {
        if (res.success) {
          if (res.success && res.result.records.length > 0) {
            var state;
            var arr = [];
            var obj = {};
            _this11.dateList = [];
            res.result.query.factors.forEach(function (item, index) {
              var factor = res.result.records[0].factor[item.code];

              if (factor) {
                if (factor.value) obj.value = factor.value; // item.standTitle = res.result.records[0].factor[item.code].standard.title
                // item.standColor = res.result.records[0].factor[item.code].standard.color
                //         if (res.result.records[0].factor[item.code].status == 1) state='合格'
                // else if(res.result.records[0].factor[item.code].status == null) state = ''
                // else state = '不合格'

                if (factor.status == 1) obj.standColor = 'green';else if (factor.status == null) obj.standColor = '';else obj.standColor = 'red';
                obj.state = state;
                obj.title = item.title;
                obj.unitName = item.unitName;
                obj.render = _this11.renderCol(item.code, '', res.result.records[0]);
                var factorFlag = factor['flag'];

                if (factorFlag) {
                  obj.flagState = factorFlag.message;
                  obj.flagCode = factorFlag.code;
                }

                state = '';
                arr.push(obj);
                obj = {};
                return item;
              }
            });
            _this11.standState = res.result.records[0].attrs.upStandard;
            _this11.standLabel = res.result.records[0].attrs.upStandard ? '达标' : '不达标'; // this.standText = res.result.records[0].currentStandard.title

            _this11.dateList = arr;
          } else {
            res.result.query.factors.forEach(function (item, index) {
              item.value = '';
              item.standColor = '';
              item.flagState = '';
              item.flagCode = '';
              item.render = '';
              return item;
            });
            _this11.standState = false;
            _this11.standLabel = '';
            _this11.dateList = res.result.query.factors;
          }
        }
      });
    }
  }
};